(() => {
  // src/switch.ts
  window.HotelCollection = window.HotelCollection || {};
  if (!window.HotelCollection.switchInitialized) {
    window.HotelCollection.switchInitialized = true;
    document.addEventListener("click", (e) => {
      const btn = e.target.closest(".switch");
      if (!btn) return;
      const isOn = btn.classList.toggle("switch--on");
      btn.setAttribute("aria-checked", String(isOn));
    });
  }
})();
